"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
/**
 * A hook that debounces a rapidly changing value.
 * @template T
 * @param {T} value - the value to be returned
 * @param {number} delay - the amount of time that should pass before the value is returned
 * @returns {T} the debounced value
 */
const useDebouncedValue = (value, delay) => {
    const [debouncedValue, setDebouncedValue] = react_1.default.useState(value);
    react_1.default.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};
exports.default = useDebouncedValue;
//# sourceMappingURL=useDebouncedValue.js.map